import { PlainObject } from '@/common/types';
import { UserInfo } from '@/common/types/user';

import { GContextInit, GFlags } from './index';

export const getGFlags = (options: {
  userInfo?: UserInfo;
  globalFlags?: PlainObject;
}): GFlags => {
  const { globalFlags } = options || {};
  return {
    ...GContextInit.globalFlags,
    ...globalFlags,
  };
};
